import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHistory } from "@fortawesome/free-solid-svg-icons";

class Cards extends React.Component {
  constructor(props) {
    super(props);
    this.handleDent = this.handleDent.bind(this);
    let statusDict = {
      budget: {
        text: "Waiting for budget",
        class: "statusYellow",
      },
      acceptance: {
        text: "Waiting for payment",
        class: "statusYellow",
      },
      rejected: {
        text: "Rejected",
        class: "statusRed",
      },
      technician: {
        text: "Waiting for technician",
        class: "statusYellow",
      },
      confirmed: {
        text: "Confirmed",
        class: "statusGreen",
      },
      progress: {
        text: "In progress",
        class: "statusGreen",
      },
      nfix: {
        text: "Won't fix",
        class: "statusRed",
      },
      fixed: {
        text: "Fixed",
        class: "statusGreen",
      },
      payment: {
        text: "Waiting for payment",
        class: "statusYellow",
      },
    };
    this.state = {
      statusDictionary: statusDict,
    };
  }

  handleDent() {
    sessionStorage.setItem("idCard", this.props.dentInfo.dent_id);
    let btnCard = document.getElementById("btnCard");
    let datos = document.getElementById("datos");
    let btnHome = document.getElementById("btnHome");
    let btnStartJob = document.getElementById("btnStartJob");

    btnCard.classList.add("d-none");
    datos.classList.remove("d-none");
    btnHome.classList.remove("d-none");

    if (
      this.state.statusDictionary[this.props.dentInfo.status]["text"] ===
      "Confirmed"
    ) {
      btnStartJob.classList.remove("d-none");
    }
    if (
      this.state.statusDictionary[this.props.dentInfo.status]["text"] ===
      "In progress"
    ) {
      datos.classList.add("d-none");
      btnHome.classList.add("d-none");
      window.location = "/job_in_progress";
    }

    datos.innerHTML += `
    <div class="mx-auto mt-3 mb-1">
                    <div class="container card-detail mt-3 mb-3" id="datos">
                    
                        <table class="table table-borderless table_color">
                        <tbody>
                          <tr>
                            <td><b>Price:</b></td>
                            <td class="color_blue">${
                               this.props.dentInfo.price ||
                              "Price to be confirmed"
                            }</td>
                          </tr>
                          <tr>                          
                          <td><b>Appointment time:</b></td>
                          <td class="color_blue">${
                            this.props.dentInfo.SelectedTimeRepair || "To be confirmed"
                          }</td>
                          </tr>
                          <tr>
                            
                            <td><b>Make:</b></td>
                            <td>${this.props.dentInfo.car_brand}</td>
                           
                          </tr>
                          <tr>
                            <td><b>Model:</b></td>
                            <td>${this.props.dentInfo.car_model}</td>
                          </tr>
                          <tr>
                            <td><b>Year:</b></td>
                            <td>${this.props.dentInfo.car_year}</td>
                          </tr>
                          <tr>                          
                          <td><b>Dent:</b></td>
                          <td>${this.props.dentInfo.dent_place}</td>
                        </tr>
                        <tr>                          
                          <td><b>Address:</b></td>
                          <td>${this.props.dentInfo.info_location}</td>
                        </tr>
                        <tr>                          
                          <td><b>Requested times:</b></td>
                          <td>${this.props.dentInfo.info_time}</td>
                        </tr>
                        </tbody>
                      </table>
                  
                    <div class="text-center mt-4 pb-4">
                        <div class="row justify-content-between ml-3 mr-3">
                            <div class="col-xs-4 mb-1">
                            <img src="${
                              this.props.dentInfo.img1
                            }" alt="imagen" class="mx-auto sizeImg"/>
                            </div>
                            <div class="col-xs-4 mb-1">
                                <img src="${
                                  this.props.dentInfo.img2
                                }" alt="imagen" class="mx-auto sizeImg"/>
                            </div>
                            <div class="col-xs-4 mb-1">
                                <img src="${
                                  this.props.dentInfo.img3
                                }" alt="imagen" class="mx-auto sizeImg" />
                            </div>
                        </div>
                    </div>
                    </div>
                    </div>
                    `;
  }
  render() {
    return (
      <React.Fragment>
         <button className="btnNull mx-auto d-block" onClick={this.handleDent}>
          <div className="d-flex mx-auto box-p">
            <div className="text-left mb-3 pt-3 pl-4">
            <p><b>{this.props.dentInfo.car_brand} {this.props.dentInfo.car_model}</b></p>
            <p>{this.props.dentInfo.dent_place}</p>
                  <span
                    id="status"
                    className={
                      this.state.statusDictionary[this.props.dentInfo.status][
                        "class"
                      ]
                    }
                  >
                    {" "}
                    <FontAwesomeIcon icon={faHistory} />{" "}
                    {
                      this.state.statusDictionary[this.props.dentInfo.status][
                        "text"
                      ]
                    }{" "}
                  </span>
           
            </div>
          </div>
        </button>
      </React.Fragment>
    );
  }
}

export default Cards;
